<div class="readonly-input-wrapper">
  <span class="readonly-input-label">{{ field.templateOptions.label }}:</span>
  <span class="readonly-input-value">
{{ formControl.value }}
  </span>
</div>
